// test variables
// export const github = "";
export const inst = "";
export const telegram = "";
export const vk = "";

export const github = "https://github.com/roso1nik";
// export const inst = "https://github.com/roso1nik";
// export const telegram = "https://github.com/roso1nik";
// export const vk = "https://github.com/roso1nik";